<template>
    <div class="content">
        <el-row class="bgW">
            <el-col :span="22">
            <el-form class="search" :inline="true" size="mini" :model="search">
                <el-form-item label="题目分类">
                    <el-select v-model="search.type" clearable class="w120" @change="handleSearchChange">
                        <el-option
                        v-for="item in options.type"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        />
                    </el-select>
                </el-form-item>
                
                <el-form-item label="题目类型">
                    <el-select v-model="search.question_type" clearable class="w120" @change="handleSearchChange">
                        <el-option
                        v-for="item in options.question_type"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        />
                    </el-select>
                </el-form-item>

                <el-form-item label="状态">
                    <el-select v-model="search.status" clearable class="w120" @change="handleSearchChange">
                        <el-option
                        v-for="item in options.status"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        />
                    </el-select>
                </el-form-item>

                <el-form-item label="题目标题">
                    <el-input 
                        v-model="search.title" 
                        placeholder="请输入标题" 
                        clearable
                        class="w180"
                        @change="handleSearchChange"
                    ></el-input>
                </el-form-item>

            </el-form>
            </el-col>
            <el-col :span="2" style="text-align: right;">
                <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
            </el-col>
        </el-row>
        <div class="accountCon">
            <div class="btnBox">
                <el-button
                    type="primary"
                    class="mb10"
                    size="mini"
                    icon="el-icon-plus"
                    @click="handleAdd"
                >新增题库</el-button>
            </div>            
            <el-row>
                <el-col :span="24">
                    <el-table
                        :data="list"
                        size="small"
                        border
                        :cell-style="$style.cellStyle"
                        :header-cell-style="$style.rowClass"
                        v-loading="loading"
                        element-loading-text="加载中..."
                    >
                        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                        <ElTableColumn label="序号" type="index" width="55" />
                        <el-table-column label="题目标题" prop="title"/>
                        <el-table-column label="题目分类" prop="type_text" width="120" align="center" />
                        <el-table-column label="排序" prop="order" width="80" align="center" >
                             <template slot-scope="scope">
                                <div  v-if="[1].includes(scope.row.type)">
                                     {{ scope.row.order }}
                                </div>
                                <div v-else>
                                    --
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="题目类型" prop="question_type_text" width="120" align="center" />
                        <el-table-column label="状态" prop="status_text" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'">
                                    {{ scope.row.status_text }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="分数范围" width="100" align="center">
                            <template slot-scope="scope">
                                <div>
                                     {{ scope.row.min_score }}-{{ scope.row.max_score }}
                                </div>
<!-- 
                                <div  v-if="[4, 5].includes(scope.row.question_type)">
                                     {{ scope.row.min_score }}-{{ scope.row.max_score }}
                                </div>
                                <div v-else>
                                    --
                                </div> -->
                            </template>
                        </el-table-column>
                        <el-table-column label="选项"  align="center">
                            <template slot-scope="scope">
                                <div  v-if="[4, 5].includes(scope.row.question_type)">
                                    --
                                </div>
                                <div v-else>
                                    <div v-for="item in scope.row.options" :key="item.code">{{ item.code}}.{{ item.text }}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建时间" prop="create_time" width="180" align="center" />
                        <el-table-column label="操作" width="200" align="center">
                            <template slot-scope="scope">
                                <el-button 
                                    size="mini" 
                                    type="text" 
                                    @click="handleView(scope.row)"
                                    class="view-btn"
                                >
                                    查看
                                </el-button>
                                <el-button 
                                    size="mini" 
                                    type="text" 
                                    @click="handleEdit(scope.row)"
                                    class="edit-btn"
                                >
                                    编辑
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 分页 -->
                    <pagination
                        class="page tc mt10"
                        :total="page.total"
                        :page.sync="page.page"
                        :limit.sync="page.page_size"
                        @pagination="getList"
                    />
                </el-col>
            </el-row>
        </div>

        <!-- 查看题库弹窗 -->
        <el-dialog
            title="查看题库"
            :visible.sync="viewDialogVisible"
            width="60%"
            :close-on-click-modal="false"
        >
            <el-descriptions :column="1" border>
                <el-descriptions-item label="ID">{{ currentQuestion.id }}</el-descriptions-item>
                <el-descriptions-item label="题目标题">{{ currentQuestion.title }}</el-descriptions-item>
                <el-descriptions-item label="题目分类">{{ currentQuestion.type_text }}</el-descriptions-item>
                <el-descriptions-item label="题目类型">{{ currentQuestion.question_type_text }}</el-descriptions-item>
                <el-descriptions-item label="状态">{{ currentQuestion.status_text }}</el-descriptions-item>
                <el-descriptions-item label="排序" v-if="[1].includes(currentQuestion.type)">{{ currentQuestion.order }}</el-descriptions-item>
                <el-descriptions-item label="分数范围" v-if="[4, 5].includes(currentQuestion.question_type)">
                    {{ currentQuestion.min_score }}-{{ currentQuestion.max_score }}
                </el-descriptions-item>
                <el-descriptions-item label="选项" v-if="currentQuestion.options && currentQuestion.options.length">
                    <el-row v-for="(option, index) in currentQuestion.options" :key="index" class="option-item">
                        {{ option.code }}.{{ option.text }}
                    </el-row>
                </el-descriptions-item>
                <el-descriptions-item label="创建时间">{{ currentQuestion.create_time }}</el-descriptions-item>
                <el-descriptions-item label="更新时间">{{ currentQuestion.update_time }}</el-descriptions-item>
            </el-descriptions>
            <span slot="footer" class="dialog-footer">
                <el-button @click="viewDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 新增/编辑题库弹窗 -->
        <el-dialog
            :title="form.id ? '编辑题库' : '新增题库'"
            :visible.sync="formDialogVisible"
            width="30%"
            :close-on-click-modal="false"
        >
            <el-form 
                ref="questionForm" 
                :model="form" 
                :rules="rules" 
                label-width="120px"
            >
                <el-form-item label="题目分类：" prop="type">
                    <el-select v-model="form.type" placeholder="请选择题目分类">
                        <el-option
                            v-for="item in options.type"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                    </el-select>
                </el-form-item>
                
                <el-form-item label="题目类型：" prop="question_type">
                    <el-select v-model="form.question_type" placeholder="请选择题目类型" @change="handleQuestionTypeChange">
                        <el-option
                            v-for="item in options.question_type"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                    </el-select>
                </el-form-item>

                <el-form-item label="题目标题：" prop="title">
                    <el-input 
                        v-model="form.title" 
                        placeholder="请输入题目标题" 
                        type="textarea"
                        rows="2"
                        @blur="checkTitleExist"
                    ></el-input>
                    <div v-if="isTitleExist" style="color:#F56C6C;font-size: 12px;">题目已存在,确定要继续添加吗</div>

                </el-form-item>

                <el-form-item 
                    label="选项：" 
                    prop="options"
                    v-if="[1, 2].includes(form.question_type)"
                >
                    <div v-for="(option, index) in form.options" :key="index" class="option-group">
                        <el-input 
                            v-model="option.text" 
                            placeholder="请输入选项内容" 
                            class="option-input"
                        >
                            <template slot="prepend">{{ String.fromCharCode(65 + index) }}</template>
                        </el-input>
                        <el-button 
                            type="text" 
                            icon="el-icon-minus" 
                            @click="removeOption(index)"
                            v-if="form.options.length > 2"
                        ></el-button>
                    </div>
                    <el-button 
                        type="text" 
                        icon="el-icon-plus" 
                        @click="addOption"
                        v-if="form.options.length < 10"
                    >
                        添加选项
                    </el-button>
                </el-form-item>
                   <!-- 排序 -->
                <el-form-item label="排序：" prop="order" v-if="[1].includes(form.type)">
                    <el-input-number 
                        v-model="form.order" 
                        :min="0" 
                        :step="1"
                        placeholder="1在最前面"
                    ></el-input-number>
                </el-form-item>

                <!-- 仅在评分题和评星题显示分数输入框 -->
                <!-- <el-form-item label="最小分数：" prop="min_score" v-if="[4, 5].includes(form.question_type)"> -->
                <el-form-item label="最小分数：" prop="min_score " v-if="[4, 5].includes(form.question_type)">
                    <el-input-number 
                        v-model="form.min_score" 
                        :min="0" 
                        :step="1"
                        placeholder="请输入最小分数"
                    ></el-input-number>
                </el-form-item>

                <el-form-item label="最大分数：" prop="max_score" v-if="[4, 5].includes(form.question_type)">
                    <el-input-number 
                        v-model="form.max_score" 
                        :min="form.min_score" 
                        :step="1"
                        placeholder="请输入最大分数"
                    ></el-input-number>
                </el-form-item>

                <el-form-item label="状态：" prop="status">
                    <el-select v-model="form.status" placeholder="请选择状态">
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="formDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="btnLoading">提交</el-button>
            </span>
        </el-dialog>

        <!-- 删除确认弹窗 -->
        <el-dialog
            title="确认删除"
            :visible.sync="deleteDialogVisible"
            width="30%"
            :close-on-click-modal="false"
        >
            <p>确定要删除该题库吗？此操作不可撤销。</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialogVisible = false">取消</el-button>
                <el-button type="danger" @click="confirmDelete">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import { mapGetters } from 'vuex'
import pagination from "@/components/Pagination";
import { clientExport } from "@/api/client";
import { getQuestionList, addQuestion, updateQuestion ,checkQuestion} from "@/api/sys";
  
// 搜索条件类
class Search {
    type = "";               // 题目分类
    question_type = "";      // 题目类型
    status = "";             // 状态
    title = "";              // 题目标题
}
class Form {
    id = "";
    type = "";
    question_type = "";
    title = "";
    options = [];
    order = 0;
    min_score = 0;
    max_score = 0;
    status = 1;
}

class Options {
    type = [
        { id: 1, name: "用户评价" },
        { id: 2, name: "满意度调查" }
    ];
    
    question_type = [
        { id: 1, name: "单选" },
        { id: 2, name: "多选" },
        //{ id: 3, name: "判断" },
        { id: 4, name: "评分" },
        { id: 5, name: "评星" },
        { id: 6, name: "简答" }
    ];
    
    status = [
        { id: 1, name: "启用" },
        { id: 2, name: "禁用" }
    ];
}

class Page {
    total = 0;
    page = 1;
    page_size = 10;
}

export default {
    name: "QuestionBank",
    components: {
        pagination
    },
    data() {
        return {
            isTitleExist: false,
            btnLoading: false,
            search: new Search(),
            form: new Form(),
            options: new Options(),
            page: new Page(),
            list: [],
            loading: false,
            idList: [],
            
            // 弹窗控制
            viewDialogVisible: false,
            formDialogVisible: false,
            deleteDialogVisible: false,
            
            // 当前操作的题目
            currentQuestion: {},
            
            // 动态验证规则
            rules: {
                type: [
                    { required: true, message: "请选择题目分类", trigger: "change" }
                ],
                question_type: [
                    { required: true, message: "请选择题目类型", trigger: "change" }
                ],
                title: [
                    { required: true, message: "请输入题目标题", trigger: "blur" },
                    { min: 2, max: 500, message: "标题长度在 2 到 500 个字符之间", trigger: "blur" }
                ],
                options: [
                    { 
                        validator: (rule, value, callback) => {
                            if ([1, 2].includes(this.form.question_type)) {
                                const emptyOptions = value.filter(option => !option.text.trim());
                                if (emptyOptions.length > 0) {
                                    return callback(new Error("选项内容不能为空"));
                                }
                            }
                            callback();
                        },
                        trigger: "blur"
                    }
                ],
                min_score: [
                    { 
                        required: false, 
                        message: "请输入最小分数", 
                        trigger: "blur" 
                    }
                ],
                max_score: [
                    { 
                        required: false, 
                        message: "请输入最大分数", 
                        trigger: "blur" 
                    }
                ],
                order: [
                    { required: true, message: "请输入排序", trigger: "blur" }
                ],
                status: [
                    { required: true, message: "请选择状态", trigger: "change" }
                ]
            }
        };
    },
    computed: {
        ...mapGetters(['userInfo']),
    },
    mounted() {
        this.getList();
    },
    methods: {
        checkTitleExist() {
            checkQuestion({ title: this.form.title }).then(res => {
                this.isTitleExist = res.length > 0 ? true : false;
            }
        )},
        // 获取列表数据
        getList(option) {
            this.loading = true;
            if (option === "search") {
                this.page = new Page();
            }
            
            getQuestionList({ ...this.search, ...this.page, is_export: 0 }).then(
                res => {     
                    this.list = res.data;
                    this.page.total = res.total;
                    this.loading = false;
                }
            ).catch(() => {
                this.loading = false;
                this.$message.error("网络错误，获取数据失败");
            });
        },

        handleSearchChange() {
        },

        handleQuestionTypeChange() {
            if (![4, 5].includes(this.form.question_type)) {
                this.form.min_score = 0;
                this.form.max_score = 0;
            } else {
                if (this.form.min_score === undefined || this.form.min_score === null) {
                    this.form.min_score = 0;
                }
                if (this.form.max_score === undefined || this.form.max_score === null || this.form.max_score < this.form.min_score) {
                    this.form.max_score = this.form.min_score || 0;
                }
            }
            
            if ([1, 2].includes(this.form.question_type) && this.form.options.length === 0) {
                this.form.options = [
                    { code: "A", text: "" },
                    { code: "B", text: "" }
                ];
            } else if (![1, 2].includes(this.form.question_type)) {
                this.form.options = [];
            }
            
            this.$nextTick(() => {
                this.$refs.questionForm.clearValidate();
            });
        },

        handleView(row) {
            this.currentQuestion = { ...row };
            this.viewDialogVisible = true;
        },

        handleEdit(row1) {
            let row = JSON.parse(JSON.stringify(row1));
            this.form = {
                id: row.id,
                type: row.type,
                question_type: row.question_type,
                title: row.title,
                order: row.order || 0,
                options: row.options ? [...row.options] : [],
                min_score: row.min_score || 0,
                max_score: row.max_score || 0,
                status: row.status
            };
            this.formDialogVisible = true;
        },
        // 新增题库
        handleAdd() {
            if (this.$refs.questionForm) {
                this.$refs.questionForm.resetFields(); 
            }
            this.isTitleExist = false;
            this.form = {
                id: "",
                type: "",
                question_type: "",
                title: "",
                order: 0,
                options: [],
                min_score: 0,
                max_score: 0,
                status: 1
            };
            this.formDialogVisible = true;
        },

        // 删除题库
        handleDelete(row) {
            this.currentQuestion = { ...row };
            this.deleteDialogVisible = true;
        },

        // 确认删除
        confirmDelete() {
            this.loading = true;
            deleteQuestion(this.currentQuestion.id).then(res => {
                if (res.code === 200) {
                    this.$message.success("删除成功");
                    this.deleteDialogVisible = false;
                    this.getList();
                } else {
                    this.$message.error(res.msg || "删除失败");
                    this.loading = false;
                }
            }).catch(() => {
                this.loading = false;
                this.$message.error("网络错误，删除失败");
            });
        },

        // 添加选项
        addOption() {
            const code = String.fromCharCode(65 + this.form.options.length);
            this.form.options.push({ code, text: "" });
        },

        // 移除选项
        removeOption(index) {
            this.form.options.splice(index, 1);
            // 重新编号
            this.form.options.forEach((option, i) => {
                option.code = String.fromCharCode(65 + i);
            });
        },

        submitForm() {
            if ([4, 5].includes(this.form.question_type)) {
                this.rules.min_score[0].required = true;
                this.rules.max_score[0].required = true;
            } else {
                this.rules.min_score[0].required = false;
                this.rules.max_score[0].required = false;
                this.form.min_score = 0;
                this.form.max_score = 0;
            }

            this.$refs.questionForm.validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const formData = { ...this.form };
                    
                    formData.options.forEach((option, index) => {
                        option.code = String.fromCharCode(65 + index);
                    });
                    formData.options = JSON.stringify(formData.options);
                    console.log(JSON.parse(formData.options), formData.options)
                    const apiMethod = formData.id ? updateQuestion : addQuestion;
                    
                    apiMethod(formData).then(res => {
                        if (res.code === 200) {
                            this.$message.success(formData.id ? "编辑成功" : "新增成功");
                            this.formDialogVisible = false;
                            this.getList();
                            this.btnLoading = false;
                        } else {
                            this.$message.error(res.msg || (formData.id ? "编辑失败" : "新增失败"));
                            this.btnLoading = false;
                        }
                    }).catch(() => {
                        this.btnLoading = false;
                        this.$message.error("网络错误，操作失败");
                    });
                }
            });
        },

        // 导出数据
        exportData(option) {
            if (option === "export") {
                this.page = new Page();
            }
            this.loading = true;
            getQuestionList({ ...this.search, ...this.page, is_export: 1 }).then(
                res => {
                    if (res.code === 200 && res.data.url) {
                        window.open(res.data.url);
                    } else {
                        this.$message.error("导出失败");
                    }
                    this.loading = false;
                }
            ).catch(() => {
                this.loading = false;
                this.$message.error("网络错误，导出失败");
            });
        },

    }
};
</script>
  
<style lang="scss" scoped>
.bgW {
    background: #fff;
    border-radius: 3px;
    padding: 10px;
    margin-bottom: 20px;
}


.page {
    margin-top: 15px;
}

// 选项样式
.option-group {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    
    .option-input {
        flex: 1;
    }
    
    .el-button {
        margin-left: 10px;
    }
}

// 查看弹窗中的选项样式
.option-item {
    margin-bottom: 8px;
    padding: 4px 0;
}

::v-deep .el-dialog__body {
    max-height: 60vh;
    overflow-y: auto;
    padding: 20px;
}

::v-deep .el-descriptions__body {
    padding-top: 10px;
}

::v-deep .el-descriptions-item {
    padding: 12px 10px;
}
</style>
